






















































































































import { Vue, Component, Prop, p } from "av-ts";
import { IQuestion } from "../../interfaces/models";

import QuestionDetails from "./QuestionDetails.vue";
import TopicChip from "../util/TopicChip.vue";
import { roundNumber } from "../../util";

@Component({
    components: {
        QuestionDetails,
        TopicChip
    }
})
export default class QuestionPreview extends Vue {
    @Prop data = p<IQuestion>({
        required: true
    });

    get pPersonalRating(): string {
        return roundNumber(this.data.personalRating!, 0);
    }

    get pQuality(): string {
        if (this.data.effectiveness! > 0) {
            return roundNumber(this.data.effectiveness!, 1);
        } else {
            return "-";
        }
    }

    get pDifficulty(): string {
        return roundNumber(this.data.difficulty!, 0);
    }

}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/questions/QuestionPreview.vue